import React from "react";
import { Radio } from "lucide-react";
import { useStreams } from "../hooks/useStreams";

/** Which of the account's streams the pages show. With only one stream it just names it. */
const StreamSwitcher: React.FC = () => {
  const { streams, selected, select, loading } = useStreams();
  if (loading || !selected) return null;

  return (
    <div className="px-8 pb-2">
      <label htmlFor="stream-switcher" className="flex items-center gap-2 text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">
        <Radio size={14} /> Stream
      </label>
      {streams.length > 1 ? (
        <select
          id="stream-switcher"
          value={selected.name}
          onChange={(e) => select(e.target.value)}
          className="w-full bg-slate-50 border border-slate-200 rounded-xl py-2 px-3 text-slate-800 font-medium outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
        >
          {streams.map((s) => (
            <option key={s.name} value={s.name}>{s.name}</option>
          ))}
        </select>
      ) : (
        <p id="stream-switcher" className="font-medium text-slate-800 break-all">{selected.name}</p>
      )}
    </div>
  );
};

export default StreamSwitcher;
